// extracted by mini-css-extract-plugin
export default {"detail":"detail---hYBLC","section":"section---cuApl"};